"use client"

import { useTranslations } from "@/lib/intl/use-translations"
import type { HeroBiomarkerOverlay } from "@/components/ui/hero-biomarker-image"

/**
 * The two sample readings on the full-body MRI ad-LP and city-page heroes
 * (`/go/fullbodymri`, `/full-body-mri-<city>`), shared so both stay in step.
 *
 * The secondary chip is the liver fat fraction, not "Liver cancer · No
 * findings · Negative": a cancer all-clear chip overstates what the scan can
 * rule out (AHD-13147). Values mirror the full-body-mri question cards in
 * `data/tests.ts`.
 */
export function useMriHeroReadings(): {
  primary: HeroBiomarkerOverlay
  secondary: HeroBiomarkerOverlay
} {
  const ut = useTranslations("ui")
  const tt = useTranslations("tests")
  return {
    primary: {
      label: tt("mriQ1Bio"),
      value: "2.2L",
      status: ut("normalRange"),
    },
    secondary: {
      label: tt("mriQ3Bio"),
      value: "3.9%",
      status: ut("normalRange"),
    },
  }
}
